import type { AssetView, CanvasDocumentV3 as CanvasDocument } from "@seedance/contracts";

export function mergeHydratedAssets(
  current: Readonly<Record<string, AssetView>>,
  assets: readonly AssetView[]
): Record<string, AssetView> {
  if (assets.length === 0) return current;
  const next = { ...current };
  assets.forEach((asset) => {
    next[asset.id] = asset;
  });
  return next;
}

export async function hydrateCanvasAssets({
  document,
  cachedAssets = new Map<string, AssetView>(),
  getAsset
}: {
  document: CanvasDocument;
  cachedAssets?: ReadonlyMap<string, AssetView>;
  getAsset(assetId: string): Promise<AssetView>;
}): Promise<AssetView[]> {
  const ids = [...new Set(document.nodes.flatMap((node) =>
    node.kind === "image" || node.kind === "video" || node.kind === "audio"
      ? [node.assetId]
      : []
  ))];
  const missingIds = ids.filter((assetId) => !cachedAssets.has(assetId));
  const results = await Promise.allSettled(missingIds.map((assetId) => getAsset(assetId)));
  return results.flatMap((result) => result.status === "fulfilled" ? [result.value] : []);
}
